const ACCOUNT_REPORTS = 'account_verification_report_id',
  ERROR = 'error',
  REPORTS = 'reports',
  TINK_ORIGIN = 'https://link.tink.com';

export { ACCOUNT_REPORTS, ERROR, REPORTS, TINK_ORIGIN };
